import styled from 'styled-components';
import { fontTitle } from 'Styles/fonts';
import { black } from 'Styles/colors';

export const AuthenticationBody = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
`;

export const Title = styled.h1`
  ${fontTitle(24)};
  color: ${black};
  text-align: center;
  margin-bottom: 16px;
`;

export const SocialContainer = styled.div`
  margin: 0 auto;
  width: 272px;
`;

export default {};
